export * from './dialog';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/md2@0.0.19_@angular+common@4.4.3_@angular+core@4.4.3_rxjs@5.5.12_zone.js@0.8.10___@angu_09eb3d05c72d83e462d3ed4c64170894/~/md2/dialog/index.js
// module id = ../../../../../../md2@0.0.19_@angular+common@4.4.3_@angular+core@4.4.3_rxjs@5.5.12_zone.js@0.8.10___@angu_09eb3d05c72d83e462d3ed4c64170894/node_modules/md2/dialog/index.js
// module chunks = 4